import { Component, Input } from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { SelectArea } from "../../../_models/index";
import {
  Form,
  NgForm,
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
} from "@angular/forms";

import * as _ from "lodash";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "selectarea",
  templateUrl: "select-area.component.html",
  styleUrls: ["./select-area.component.css"],
})
export class SelectAreaComponent extends BaseComponent {
  @Input() form: NgForm;
  @Input() selectAreaData?: SelectArea;
  formGroup: FormGroup;

  circles: any[];
  selectedCircle: any;
  counties: any[];
  selectedCounty: any;
  nests: any[];
  selectedNest: any;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    this.handleEntities();
    this.formGroup = new FormGroup({});
    if (this.isShowCircle()) {
      this.formGroup.addControl(
        "circle",
        new FormControl(
          this.selectedCircle,
          !this.selectAreaData || this.selectAreaData.shouldValidate
            ? [Validators.required]
            : null
        )
      );
    }

    this.formGroup.addControl(
      "county",
      new FormControl(
        this.selectedCounty,
        !this.selectAreaData || this.selectAreaData.shouldValidate
          ? [Validators.required]
          : null
      )
    );

    this.formGroup.addControl(
      "nest",
      new FormControl(
        this.selectedNest,
        !this.selectAreaData || this.selectAreaData.shouldValidate
          ? [Validators.required]
          : null
      )
    );
  }

  isShowCircle() {
    return !this.selectAreaData || this.selectAreaData.isCirclesVisible;
  }

  handleEntities() {
    this.circles = this.base.user.circles;
    this.selectedCircle =
      this.circles && this.circles.length && this.circles.length == 1
        ? this.circles[0].circleId
        : null;
    this.counties = this.selectedCircle
      ? _.filter(this.base.user.counties, {
          parent: Number(this.selectedCircle),
        })
      : this.base.user.counties;
    this.selectedCounty =
      this.counties && this.counties.length && this.counties.length == 1
        ? this.counties[0].countyId
        : null;
    this.nests = this.selectedCounty
      ? _.filter(this.base.user.nests, {
          parent: Number(this.selectedCounty),
        })
      : this.base.user.nests;

    this.selectedNest =
      this.nests && this.nests.length && this.nests.length == 1
        ? this.nests[0].nestId
        : null;
    this.handleNullEntites();
  }

  handleNullEntites() {
    if (this.selectAreaData && !this.selectAreaData.allowNullEntity) {
      this.circles = this.circles
        ? _.filter(this.circles, (c) => {
            return c.circleId != 0;
          })
        : this.circles;
      this.counties = this.counties
        ? _.filter(this.counties, (c) => {
            return c.countyId != 0;
          })
        : this.counties;
      this.nests = this.nests
        ? _.filter(this.nests, (c) => {
            return c.nestId != 0;
          })
        : this.nests;
    }
  }

  selectCircle(event) {
    this.selectedCircle = event.target.value;

    this.counties =
      this.selectedCircle && this.selectedCircle != null
        ? _.filter(this.base.user.counties, {
            parent: Number(this.selectedCircle),
          })
        : this.base.user.counties;

    this.selectedCounty =
      this.counties && this.counties.length && this.counties.length == 1
        ? this.counties[0].countyId
        : undefined;
    this.nests = this.selectedCounty
      ? _.filter(this.base.user.nests, {
          parent: Number(this.selectedCounty),
        })
      : this.base.user.nests;

    this.selectedNest =
      this.nests && this.nests.length && this.nests.length == 1
        ? this.nests[0].nestId
        : undefined;
    this.handleNullEntites();
  }

  selectCounty(event) {
    this.selectedCounty = event.target.value;

    this.nests =
      this.selectedCounty && this.selectedCounty != null
        ? _.filter(this.base.user.nests, {
            parent: Number(this.selectedCounty),
          })
        : this.base.user.nests;
    this.selectedNest =
      this.nests && this.nests.length && this.nests.length == 1
        ? this.nests[0].nestId
        : undefined;

    this.handleNullEntites();
  }

  selectNest(event) {
    this.selectedNest = event.target.value;
  }

  submit() {
    if (this.form.submitted && this.formGroup.valid) {
      let r = {};
      if (this.selectedCircle && this.selectedCircle != "null")
        r["circle"] = this.selectedCircle;
      if (this.selectedCounty && this.selectedCounty != "null")
        r["county"] = this.selectedCounty;
      if (this.selectedNest && this.selectedNest != "null")
        r["nest"] = this.selectedNest;
      return r; //this.formGroup.getRawValue();
    } else return;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/select-area/select-area.component.ts